/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap')
require('./vendor/fontawesome-all.min')
require('jssocials')

window.Vue = require('vue')

import VueMasonry from 'vue-masonry-css'

Vue.use(VueMasonry)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('point-component', require('./components/PointComponent.vue'))
Vue.component('main-points-component', require('./components/MainPointsComponent.vue'))
Vue.component('rich-text-component', require('./components/RichTextComponent'))

Vue.component('number-1', require('./components/participant-numbers/1.vue'))
Vue.component('number-2', require('./components/participant-numbers/2.vue'))
Vue.component('number-3', require('./components/participant-numbers/3.vue'))
Vue.component('number-4', require('./components/participant-numbers/4.vue'))
Vue.component('number-5', require('./components/participant-numbers/5.vue'))
Vue.component('number-6', require('./components/participant-numbers/6.vue'))
Vue.component('number-7', require('./components/participant-numbers/7.vue'))
Vue.component('number-8', require('./components/participant-numbers/8.vue'))
Vue.component('number-9', require('./components/participant-numbers/9.vue'))

Vue.component('participants', require('./components/participants'))
Vue.component('news-feed', require('./components/news-feed.vue'))
Vue.component('news-card', require('./components/news-card.vue'))

const app = new Vue({
    el: '#app'
})

$(document).ready(function() {
    $('.collapse').on('show.bs.collapse', function() {
        $('.nav-mobile').addClass('open')
        $('body, html').css('overflow', 'hidden')
    })
    $('.collapse').on('hidden.bs.collapse', function() {
        $('.nav-mobile').removeClass('open')
        $('body, html').css('overflow', 'auto')
    })

    if ($('#share').length > 0) {
        jsSocials.setDefaults('facebook', { logo: 'fab fa-facebook-f' })
        jsSocials.setDefaults('whatsapp', { logo: 'fab fa-whatsapp' })
        jsSocials.setDefaults('email', { logo: 'fas fa-envelope' })
        $('#share').jsSocials({
            showLabel: false,
            showCount: false,
            shares: ['facebook', 'whatsapp', 'email']
        })
        $(window).on('scroll', function() {
            let offset = $('.share-container')[0].getBoundingClientRect().top
            if (offset < 90 && $(window).width() > 786) {
                $('#share').css('width', $('#share').width())
                $('#share:not(float)').addClass('float')
            } else {
                $('#share.float').removeClass('float')
            }
        })
    }

    if ($('.square').length > 0) {
        $('.square').height($('.square:first').width())
    }
})

var header = document.getElementById('balansHeader')
$('#menuWp').waypoint({
    handler: function(direction) {
        if (direction === 'down') {
            header.classList.add('abs-pre-fixed')
        } else {
            header.classList.remove('abs-pre-fixed')
        }
    },
    offset: '100px'
})
$('#menuWp').waypoint({
    handler: function(direction) {
        if (direction === 'down') {
            header.classList.add('abs-fixed')
        } else {
            header.classList.remove('abs-fixed')
        }
    },
    offset: '0%'
})



// WEBPACK FOOTER //
// ./resources/assets/js/app.js